import { LibraryPageContext } from "@/pages/library_v2/components/filesView/context";
import {
  FileStatus,
  type LibraryFolder,
} from "@/pages/library_v2/components/filesView/types";

import { useCallback, useContext, useState } from "react";

import { twMerge } from "tailwind-merge";

import { FolderActionsView } from "./folderActionsView";
import { FolderRenameView } from "./folderRenameView";

type Props = {
  folder: LibraryFolder;
  isActive: boolean;
};

export const FolderView: React.FC<Props> = ({ folder, isActive }) => {
  const { setSelectedFolderName, setSelectedViewId, setSearchValue } =
    useContext(LibraryPageContext);
  const [isRenaming, setIsRenaming] = useState<boolean>(false);

  const onFolderClick = useCallback(
    (folderName: string) => {
      setSelectedFolderName(folderName);
      setSelectedViewId(FileStatus.PUBLISHED);
      setSearchValue("");
    },
    [setSelectedFolderName, setSelectedViewId, setSearchValue],
  );

  if (isRenaming) {
    return <FolderRenameView folder={folder} setIsRenaming={setIsRenaming} />;
  }

  return (
    <div
      className={twMerge(
        "group flex items-center gap-[2px] rounded-[7px]",
        isActive ? "bg-[#F3F5AE]" : "hover:bg-grey1",
      )}
    >
      <button
        type="button"
        onClick={() => onFolderClick(folder.name)}
        className={twMerge(
          "min-w-0 flex-1 cursor-pointer py-[7px] pr-[3px] pl-[9px] text-left text-[12.5px] text-[#1D1C1C]",
          isActive ? "font-semibold" : "font-medium",
        )}
      >
        <span className="block truncate">{folder.name}</span>
      </button>

      <FolderActionsView folder={folder} setIsRenaming={setIsRenaming} />
    </div>
  );
};
